import $api from "../api/axios";

type TUpdateOrganizationAiModelRequest = {
  defaultAiModelOverride: string | null;
};

type TUpdateOrganizationAiModelResponse = {
  status: number;
  message: string;
};

export async function updateOrganizationAiModel(
  orgId: number,
  request: TUpdateOrganizationAiModelRequest
): Promise<TUpdateOrganizationAiModelResponse> {
  const response = await $api.patch(`/organizations/${orgId}/ai-model`, request);
  return response.data;
}

type TUpdateOrganizationStatusRequest = {
  status: "active" | "archived";
};

type TUpdateOrganizationStatusResponse = {
  status: number;
  message: string;
};

export async function updateOrganizationStatus(
  orgId: number,
  request: TUpdateOrganizationStatusRequest
): Promise<TUpdateOrganizationStatusResponse> {
  const response = await $api.patch(`/organizations/${orgId}/archive`, request);
  return response.data;
}

type TUpdateTwoFactorRequest = { twoFactorEnabled: boolean };
type TUpdateTwoFactorResponse = { status: number; message: string; data: { twoFactorEnabled: boolean } };

export async function updateOrganizationTwoFactor(
  orgId: number,
  request: TUpdateTwoFactorRequest
): Promise<TUpdateTwoFactorResponse> {
  const response = await $api.patch(`/organizations/${orgId}/two-factor`, request);
  return response.data;
}

type TUpdateEnhancedPasswordPolicyRequest = { enhancedPasswordPolicyEnabled: boolean };
type TUpdateEnhancedPasswordPolicyResponse = { status: number; message: string };

export async function updateOrganizationEnhancedPasswordPolicy(
  orgId: number,
  request: TUpdateEnhancedPasswordPolicyRequest
): Promise<TUpdateEnhancedPasswordPolicyResponse> {
  const response = await $api.patch(`/organizations/${orgId}/enhanced-password-policy`, request);
  return response.data;
}

type TCreateOrganizationRequest = { name: string };
type TCreateOrganizationResponse = { status: number; message: string; data: { id: number; name: string } };

export async function createOrganization(request: TCreateOrganizationRequest): Promise<TCreateOrganizationResponse> {
  const response = await $api.post("/organizations", request);
  return response.data;
}
